import { Auth } from '@nackle/bridge';
import { idURL } from 'endpoints';

const auth = new Auth( {
    authority: idURL
} );

export default auth;

export function authRequestMiddleware ( url, options = {} ) {
    if ( !auth || !auth.state || !auth.state.access_token ) {
        return;
    }

    options.headers = {
        ...( options.headers || {} ),
        'authorization': `Bearer ${ auth.state.access_token }`
    };
}

export function authRouteMiddleware( action, nextRoute, prevRoute ) {
    // we aren't signed in yet, so continue
    if ( !auth.state.access_token ) {
        return action.ok();
    }

    const nextCompanyId = nextRoute?.state?.params?.companyId;
    // if the next companyId is the same as the last companyId, continue
    if ( nextCompanyId === auth.state.company_id ) {
        return action.ok();
    }

    // switch to the new company
    auth.delegate( nextCompanyId ).then( () => {
        action.ok();
    } ).catch( error => {
        console.error( error );
    } );
}

export function hasPermission( permission ) {
    const [ app, key ] = permission.split( '.', 2 );

    const userPermissions = auth?.state?.claims?.permissions;
    if ( !userPermissions ) {
        return false;
    }
    const appPermissions = userPermissions[ app ];
    if ( !Array.isArray( appPermissions ) ) {
        return false;
    }
    return appPermissions.includes( key );
}

export const permissions = {
    CMX_EDIT_KEY: 'cmx.edit-key',
    CMX_IMPORT_CONTENT: 'cmx.import-content',
    CMX_EXPORT_CONTENT: 'cmx.export-content',
    CMX_EDIT_CUSTOM_STRING: 'cmx.edit-custom-string',
    CMX_CREATE_KEY: 'cmx.create-key',
    CMX_EDIT_GOLD_STRING: 'cmx.edit-gold-string',
    CMX_CREATE_PROJECT: 'cmx.create-project'
};